import loadItemsOnDateRangeChange from './loadItemsOnDateRangeChange';
import datapoints from '../datapoints';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { updateDateRange } from 'owa-calendar-surface';
import { CalendarSurfaceStore, updateAllDayWellExpanded } from 'owa-calendar-surface-dategrid';
import { DateRange } from 'owa-datetime-utils';

/**
 * Processes date range change with UpdateDateRange CTQ
 */
export let processDateRangeChange = createLegacyActionWithDatapoint(
    'processDateRangeChange',
    datapoints.UpdateDateRange
)(function processDateRangeChange(newDateRange: DateRange, store: CalendarSurfaceStore) {
    updateAllDayWellExpanded(store, false, 'DateRangeChange');
    updateDateRange(newDateRange, store);
    return loadItemsOnDateRangeChange(newDateRange, store.dateRangeType);
});
